/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import StudentInfoDocuments from './StudentInfoDocuments';

/**
 * The StudentInfo model module.
 * @module model/StudentInfo
 * @version 1.0.0
 */
class StudentInfo {
    /**
     * Constructs a new <code>StudentInfo</code>.
     * @alias module:model/StudentInfo
     */
    constructor() { 
        
        StudentInfo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentInfo} obj Optional instance to populate.
     * @return {module:model/StudentInfo} The populated <code>StudentInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentInfo();

            if (data.hasOwnProperty('validated')) {
                obj['validated'] = ApiClient.convertToType(data['validated'], 'Boolean');
            }
            if (data.hasOwnProperty('documents')) {
                obj['documents'] = StudentInfoDocuments.constructFromObject(data['documents']);
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} validated
 */
StudentInfo.prototype['validated'] = undefined;

/**
 * @member {module:model/StudentInfoDocuments} documents
 */
StudentInfo.prototype['documents'] = undefined;






export default StudentInfo;

